import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { isFaireDirectVariant } from "@faire/retailer-visitor-shared/components/AppSignUp/AppSignUpModalVariant";
import { TermsAndPrivacyPolicyDisclaimer } from "@faire/retailer-visitor-shared/components/Legal/TermsAndPrivacyPolicyDisclaimer";
import { useFaireDirectBrand } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { useFaireDirectFirstOrderIncentive } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectFirstOrderIncentive/useFaireDirectFirstOrderIncentive";
import { getSettingFaireDirectCreditExpiresInDays } from "@faire/retailer-visitor-shared/settings/getSettingFaireDirectCreditExpiresInDays";
import { Span } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
export var Disclaimer = function(param) {
    var modalVariant = param.modalVariant, textAlign = param.textAlign;
    var faireDirectBrand = useFaireDirectBrand().faireDirectBrand;
    var brandCompanyName = faireDirectBrand === null || faireDirectBrand === void 0 ? void 0 : faireDirectBrand.name;
    var formattedMaxPercentageDiscountAmount = useFaireDirectFirstOrderIncentive().formattedMaxPercentageDiscountAmount;
    var getFaireDirectDisclaimerLine = function() {
        return /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "wu2jy9",
            defaultMessage: [
                {
                    type: 0,
                    value: "*Available for retailers who are new to Faire. Max discount of "
                },
                {
                    type: 1,
                    value: "maximumDiscountMoney"
                },
                {
                    type: 0,
                    value: " & 1 year of free shipping with "
                },
                {
                    type: 1,
                    value: "brandCompanyName"
                },
                {
                    type: 0,
                    value: " only. Expires "
                },
                {
                    type: 1,
                    value: "expiresInDaysNumber"
                },
                {
                    type: 0,
                    value: " days after signup."
                }
            ],
            values: {
                maximumDiscountMoney: formattedMaxPercentageDiscountAmount,
                brandCompanyName: brandCompanyName !== null && brandCompanyName !== void 0 ? brandCompanyName : "",
                expiresInDaysNumber: getSettingFaireDirectCreditExpiresInDays()
            }
        });
    };
    var isFaireDirect = isFaireDirectVariant(modalVariant);
    return /*#__PURE__*/ _jsxs(Span, {
        variant: "labelSansRegular",
        color: Core.text.subdued,
        align: isFaireDirect ? "start" : textAlign !== null && textAlign !== void 0 ? textAlign : "center",
        children: [
            isFaireDirect ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    getFaireDirectDisclaimerLine(),
                    " "
                ]
            }) : null,
            /*#__PURE__*/ _jsx(TermsAndPrivacyPolicyDisclaimer, {})
        ]
    });
};
